import { RouterModule, Routes } from "@angular/router";
import { WebAppFeedbackComponent } from "./feedbacks.component";
import { NgModule } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { WebAppFeedbackService } from "./feedbacks.service";
import { WebAppSharedModule } from "../../shared/shared.module";

const routes: Routes = [
	{
		path: '',
		component: WebAppFeedbackComponent,
		data: { title: 'Modules.Feedbacks.PageTitle' }
	}
];

@NgModule({
	declarations: [WebAppFeedbackComponent],
	imports: [CommonModule, WebAppSharedModule, RouterModule.forChild(routes)],
	providers: [WebAppFeedbackService, DatePipe]
})

export class WebAppFeedbacksModule { }